import ContentLayout from "../components/layout/ContentLayout";
import SearchBar from "../components/SearchBar";
import { BsThreeDotsVertical } from "react-icons/bs";
import FeaturesBar from "../components/FeaturesBar";
import { getAllBusinesses } from "../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Empty, Pagination, Spin } from "antd";
import { IoSearch } from "react-icons/io5";
import Search from "antd/es/transfer/search";

export default function Features() {
  // Pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState();

  const { isLoading: businessLoading, data: businessesData } = useQuery({
    queryKey: ["Business-accounts", page, limit, search],
    queryFn: () => getAllBusinesses({ page, limit, search }),
    keepPreviousData: true,
  });

  const businesses = businessesData?.data?.businesses || [];
  const pagination = businessesData?.data?.pagination || {};

  const currentPage = page; // Use local state to control pagination reliably
  const total = pagination.totalCount || 0;
  const pageSize = limit; // Keep limit as the controlled page size

  return (
    <ContentLayout
      header={
        <>
          <Search
            placeholder="Search by Name or Slug"
            enterButton={<IoSearch />}
            size="large"
            className="search_bar"
            onChange={(e) => setSearch(e.target.value)}
            allowClear
          />
          <div className="features-bar gray">
            <h6>NAME</h6>
            <BsThreeDotsVertical />
          </div>
          {businessLoading ? (
            <Spin
              style={{
                width: "100%",
              }}
            />
          ) : businesses.length === 0 ? (
            <Empty
              style={{ marginTop: "2rem", width: "100%" }}
              description="No businesses found"
            />
          ) : (
            businesses.map((item) => (
              <FeaturesBar
                key={item.urn}
                name={item.name}
                email={item.config?.contact?.email || "-"}
                link={`${item.account_urn}/${item.urn}/${item.slug}`}
              />
            ))
          )}
          {/* Pagination (Ant Design) */}
          {pagination.totalPages > 1 && (
            <div style={{ marginTop: "1rem", textAlign: "center" }}>
              <Pagination
                current={currentPage}
                total={total}
                pageSize={pageSize}
                showSizeChanger
                onChange={(newPage, newPageSize) => {
                  setPage(newPage);
                  setLimit(newPageSize);
                }}
                onShowSizeChange={(current, newSize) => {
                  setPage(1); // Reset to first page when size changes
                  setLimit(newSize);
                }}
              />
            </div>
          )}
        </>
      }
    ></ContentLayout>
  );
}
